"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApMenuItemStatic = exports.ApMenuItemStaticInternal = void 0;
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
var styles_1 = require("./styles");
exports.ApMenuItemStaticInternal = react_1.forwardRef(function (props, ref) {
    var children = props.children, icon = props.icon, className = props.className, textClassName = props.textClassName, rest = __rest(props, ["children", "icon", "className", "textClassName"]);
    return (React.createElement(styles_1.MenuItem, __assign({}, rest, { isStatic: true, className: className, ref: ref }),
        icon && React.createElement(styles_1.IconWrapper, null, icon),
        React.createElement(styles_1.MenuItemText, { className: textClassName }, children)));
});
exports.ApMenuItemStatic = react_1.memo(exports.ApMenuItemStaticInternal);
//# sourceMappingURL=ApMenuItemStatic.js.map